import { errors } from 'redux-rest-reducer';

import { ACTIONS } from '@~/actions/chat-events';
import { ACTIONS as logoutActions } from '@~/actions/logout';

const initialState = {
  toggleChatWindow: false,
  newTeacherMessageCount: 0,
};

export default function defaultExport(state = initialState, { type, payload }) {
  switch (type) {
    case ACTIONS.OPEN_CHAT_WINDOW:
      // eslint-disable-next-line no-case-declarations
      const updatedState = {
        toggleChatWindow: payload.event,
      };

      if (payload.event) {
        updatedState.newTeacherMessageCount = 0;
      }

      return {
        ...state,
        ...updatedState,
      };
    case ACTIONS.NEW_MESSAGE_COUNT:
      // eslint-disable-next-line no-case-declarations
      const newState = {
        newTeacherMessageCount: payload.messageCount,
      };

      if (state.toggleChatWindow) {
        newState.newTeacherMessageCount = 0;
      }

      return {
        ...state,
        ...newState,
      };
    case logoutActions.POST_SUCCESS:
    case errors[401]:
      return initialState;
    default:
      return state;
  }
}
